import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS } from '@/nova/theme/tokens';

/* Rendered inside a model dropdown option, under the model name. Resets the option's nowrap so the blurb wraps. */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 3px;
  white-space: normal;
  font-weight: 400;
`;

export const Blurb = styled(Text)`
  font-size: 12px;
  line-height: 1.4;
  color: ${COLORS.textMuted};
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
`;

export const MetaText = styled(Text)`
  font-size: 11px;
  color: ${COLORS.textFaint};
`;

export const Sep = styled.span`
  font-size: 11px;
  color: ${COLORS.textFaint};
`;
